













import { Prop, Component, Vue } from "vue-property-decorator";
import VChartRow from "./VChartRow.vue";

@Component({
  components: {
    VChartRow
  }
})
export default class VChartHeader extends Vue {
  @Prop({ required: true }) cols!: string[];
}
